import React from 'react';
import { ANNOUNCEMENTS } from '../mock/mock';

export default function AnnouncementBar() {
  const items = [...ANNOUNCEMENTS, ...ANNOUNCEMENTS, ...ANNOUNCEMENTS];
  return (
    <div style={{ background: 'var(--gk-green-light)', color: '#faf6ee' }} className="text-[12px] md:text-[13px] py-2 overflow-hidden">
      <div className="marquee-track px-6">
        {items.map((a, i) => (
          <span key={i} className="inline-flex items-center gap-2">
            <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: 'var(--gk-gold)' }} />
            <span>{a.text} {a.highlight && <strong className="font-bold" style={{ color: 'var(--gk-gold)' }}>{a.highlight}</strong>}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
